import { AddressDetails } from './AddressDetails'

export default AddressDetails
